import { render, staticRenderFns } from "./add-notice.vue?vue&type=template&id=177754ce"
import script from "./add-notice.vue?vue&type=script&lang=ts"
export * from "./add-notice.vue?vue&type=script&lang=ts"
import style0 from "./add-notice.vue?vue&type=style&index=0&id=177754ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports